import React, { useState } from 'react';
import { mediaUrl } from '../../../utils/mediaUrl';
import { logEvent } from '../../../utils/analytics';

const AudioMessage = ({ message, avatarSrc, phoneImageSrc, memberId }) => {
  const { audioPath, timestamp } = message;
  const [showAudio, setShowAudio] = useState(false);
  const avatarUrl = mediaUrl(avatarSrc);

  const toggleAudioPlayer = () => {
    setShowAudio(!showAudio);
  };

  return (
    <div className="message">
      <img
        className="avatar"
        src={avatarUrl || undefined}
        alt="成員頭像"
        onError={(e) => {
          e.target.onerror = null;
          e.target.removeAttribute('src');
        }}
      />
      <div className="message-content">
        <div className="message-text audio-container">
          {audioPath && (
            <>
              <img
                className="audio-placeholder"
                src={mediaUrl(phoneImageSrc)}
                alt="Phone"
                onClick={toggleAudioPlayer}
                style={{
                  width: '100%',
                  cursor: 'pointer'
                }}
              />
              {showAudio && (
                <audio
                  controls
                  onPlay={() => logEvent('media_view', { media_type: 'audio', member_id: memberId })}
                  className="message-audio"
                  style={{ width: '100%', marginTop: '10px' }}
                >
                  <source src={mediaUrl(audioPath)} type="audio/mp4" />
                  您的瀏覽器不支援音訊播放
                </audio>
              )}
            </>
          )}
        </div>
        <div className="timestamp">{timestamp}</div>
      </div>
    </div>
  );
};

export default AudioMessage;